import ContentWrapper from "../ContentWrapper/ContentWrapper"
import TopHeading from "../TopHeading/TopHeading"
import OrderDetailsWrapper from "./OrderDeatilsWrapper/OrderDetailsWrapper"



function OrderAmountDetails({ data }) {
    return (
        <div>

            <TopHeading heading={"Order Details"} />
            <ContentWrapper>
                <OrderDetailsWrapper data={data} />
            </ContentWrapper>
        </div>
    )
}

export default OrderAmountDetails